import React from 'react';
import {
  TextareaAutosize,
  TextareaAutosizeProps,
  Typography,
} from '@mui/material';
import './ArrTextArea.scss';

export interface MultilineTextInputProps extends Omit<
  TextareaAutosizeProps,
  'onChange'
> {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  maxRows?: number;
  isResponsive?: boolean;
  ariaLabel?: string;
  helperText?: string;
  maxLength?: number;
  error?: boolean;
  resizable?: boolean;
  className?: string;
  dataTestId: string;
}

const ArrTextArea: React.FC<MultilineTextInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
  disabled = false, // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isResponsive,
  rows,
  maxRows = 8,
  ariaLabel,
  helperText,
  maxLength = 500,
  error = false,
  resizable = false,
  className = '',
  dataTestId,
  ...rest
}) => {
  return (
    <div
      className={`arr-textarea-wrapper ${error ? 'error' : ''} ${resizable ? 'resizable' : ''} ${className}`}
      data-testid={`arr-text-area-di-${dataTestId}`}
    >
      {label && (
        <label
          className="arr-textarea-label"
          data-testid={`Arr-textarea-label-${dataTestId}`}
        >
          {label}
        </label>
      )}
      <TextareaAutosize
        className="arr-textarea-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || ''}
        disabled={disabled}
        minRows={rows}
        maxRows={maxRows}
        maxLength={maxLength}
        aria-label={ariaLabel || label || 'Multiline Text Input'}
        style={{width: '100%'}}
        data-testid={`arr-keyword-textarea-input-${dataTestId}`}
        {...rest}
      />
      {helperText && (
        <Typography
          className="arr-textarea-helper"
          data-testid="arr-textarea-helper"
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
};

export default ArrTextArea;
